<div class="popover-trigger" [popoverTrigger]="popoverContent" #popover="popoverTrigger">
  <ng-content select="[trigger]"></ng-content>
</div>

<ng-template #popoverContent>
  <div class="madar--v2">
    <mat-card class="popover" [class.mat-elevation-z3]="enableShadow" [style.width]="width">
      <mat-card-header [class.d-none]="!titleElement?.childNodes?.length">
        <mat-card-title>
          <div #titleElement><ng-content select="[head]"></ng-content></div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ng-content></ng-content>

        <button mat-icon-button class="btn--small popover__action" type="button" (click)="popover.close()" *ngIf="dismissible">
          <mat-icon class="icon icon--xsmall">close</mat-icon>
        </button>
      </mat-card-content>

      <mat-card-actions #footerElement [class.d-none]="!footerElement.childNodes?.length">
        <ng-content select="[footer]"></ng-content>
      </mat-card-actions>
    </mat-card>
  </div>
</ng-template>
